<template>
  <div class="app-container">
    <wt-form-table :form.sync="form" @on-button-action="onButtonAction">
      <wt-form-table-list ref="boxTransportationTableRef" slot="wtFormTableList" :form.sync="form" @on-button-action="onButtonAction">
<!--        <template slot="companyId" slot-scope="data">-->
<!--          <span>{{data.row.companyId | FILTER_Company}}</span>-->
<!--        </template>-->
      </wt-form-table-list>
    </wt-form-table>
  </div>
</template>

<script>

export default {
  data() {
    return {
      imgUrl: window.wtConst.FILE_SERVER_URL,
      form: { //  表单数据
        isFormLoading: false,
        formCode: 'MODULE_BOX_TRANSPORTATION_LIST',
        formComponent: {
          list: { type: 'default', value: '/modules/ablHardwareStats/dataList' }
        },
        formInputsData: [
          { name: '统计时间',
            key: 'status',
            value: 'day',
            type: 'select',
            data: [
              { label: '天', value: 'day' },
              { label: '周', value: 'week' },
              { label: '月', value: 'month' },
              { label: '年', value: 'year' }
            ] },
          { name: 'SN', key: 'sn', value: '', type: 'text' },
          { name: '查询日期', key: 'createTimeRange', value: [], type: 'datetime' }],
        formButtonsData: [{ name: '导出Excel',
          key: 'EXPORT',
          action: 'EXCEL',
          hidden: false,
          url: window.wtConst.BASE_API + '/modules/ablHardwareStats/exportExcelQy',
          fileName: '单个箱体清运计',
          permission: 'EXPORT' }],
        formTableData: [
          { name: '公司名称', key: 'companyName' },
          { name: 'SN', key: 'sn', type: 'text' },
          { name: '清运次数', key: 'clearCount', type: 'text' },
          { name: '违投上报次数', key: 'unlawfulDeliveryCount', type: 'text' },
          { name: '违投重量(千克)', key: 'unlawfulDeliveryWeight', type: 'text' },
          { name: '违投金额(元)', key: 'unlawfulDeliveryAmount', type: 'text' },
          { name: '清运金额(元)', key: 'collectorTotalPayment', type: 'text' },
          { name: '清运人数', key: 'clearNb', type: 'text' },
          { name: '清运重量(千克)', key: 'clearWeight', type: 'text' },
          { name: '分润金额(元)', key: 'netProfit', type: 'text' },
          { name: '创建时间', key: 'createdAt', type: 'text', sortable: 'custom' }],
        formTableButtonsData: [],
        formResult: {},
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: false, buttonHidden: true, index: false }
      }
    }
  },
  methods: {
    /*  ------------------------- 按钮相关  -------------------------  */
    onButtonAction(data) {
      if (data && data.item) {
        // if (data.item.action === 'VIEW' || data.item.action === 'EDIT') {
        // this.$store.dispatch('setLopperDetailData', data.row)
        // }
      }
    }
  }
}
</script>
